import React from "react";
import Style from "../../style/travelagent.module.scss";
import { useState } from "react";
import { useEffect } from "react";

const TravelAgent = () => {
  const [data, setData] = useState<any>({ agencies: [], companions: [] });

  useEffect(() => {
    fetch("/data/travel.json")
      .then((res) => res.json())
      .then((res) => {
        setData(res);
      });
  }, []);

  const formatDate = (dateStr: string) => {
    return new Date(dateStr).toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const relativeDate = (dateStr: string) => {
    const target = new Date(dateStr);
    const today = new Date();
    const diffTime = target.setHours(0, 0, 0, 0) - today.setHours(0, 0, 0, 0);
    const diffDays = Math.floor(diffTime / (1000 * 60 * 60 * 24));

    if (diffDays === 0) return "today";
    if (diffDays === 1) return "tomorrow";
    if (diffDays === -1) return "yesterday";
    if (diffDays < -1) return `${Math.abs(diffDays)} days ago`;
    return `in ${diffDays} days`;
  };
  return (
    <div className={Style.container}>
      <div className={Style.wrapper}>
        <div className={Style.mainbox}>
          <div className={Style.leftSide}>
            <h2>Air Travel Agents </h2>
            {data.agencies.slice(0, 5).map((item: any, index: number) => {
              return (
                <div className={Style.Content} key={index}>
                  <div className={Style.agent}>
                    <a
                      href={`/travel/agent/${item.name
                        .toLowerCase()
                        .replaceAll(" ", "-")}`}
                    >
                      {item.name}
                    </a>
                    <h3>
                      {item.address},{" "}
                      <a
                        href={`/travel/city/${item.city
                          .toLowerCase()
                          .replaceAll(" ", "-")}`}
                      >
                        {item.city}
                      </a>
                    </h3>
                  </div>
                  <div className={Style.review}>
                    <div className={Style.star}>
                      {[...Array(5)].map((_, i) => (
                        <i
                          key={i}
                          className={
                            item.reviews > 0 && i < Math.round(item.rating)
                              ? "fa-solid fa-star"
                              : "fa-regular fa-star"
                          }
                        ></i>
                      ))}
                    </div>
                    <h4>({item.reviews}) Review</h4>
                    <p>
                      <a href={`/travel/agent/${item.name}`}>
                        {item.reviews > 0
                          ? "Write a Review"
                          : "Be the first to Review"}
                      </a>
                    </p>
                  </div>
                  <div className={Style.button}>
                    <button>Get Quotes</button>
                  </div>
                </div>
              );
            })}
            <div className={Style.viewbutton}>
              <a href="/travel/agent">View More</a>
            </div>
          </div>
          <div className={Style.rightSide}>
            <h2>Recent Travel Companion Requests</h2>
            {[...data.companions]
              .sort((a, b) => {
                const dateA = new Date(a.review_details?.[0]?.date || 0);
                const dateB = new Date(b.review_details?.[0]?.date || 0);
                return dateB.getTime() - dateA.getTime();
              })
              .slice(0, 4)
              .map((companion: any) => {
                return (
                  <div className={Style.rightContent}>
                    <h4>
                      Self leaving from {companion.origin_city} to{" "}
                      {companion.destination_city} on{" "}
                      {formatDate(companion.travel_date)}
                    </h4>
                    <p>
                      Posted {relativeDate(companion.review_details?.[0]?.date)}{" "}
                      by {companion.name}
                    </p>
                    <button>Send Response</button>
                  </div>
                );
              })}
            <div className={Style.button}>
              <a href="/travel/travelcampion">View More</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TravelAgent;
